var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c(this.$route.meta.layout || 'div',{tag:"component"},[_c('router-view',{attrs:{"layout":_vm.layout},on:{"update:layout":function($event){_vm.layout=$event}}})],1),_c('TestLoader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }